import { unwrapLessonChirpError } from 'academy-common-lib/features/lessons/lessonUtils';
import { useGetHydratedLessonQuery } from '../../../__generated__/chirp/com/hubspot/academy/catalog/rpc/LessonChirpService.hooks';
import { useGetByIdQuery } from '../../../__generated__/chirp/com/hubspot/academy/catalog/rpc/noauth/LessonPublicChirpService.hooks';
import { unwrapPublicLessonChirpError } from './lessonUtils';
export const useFullLesson = ({
  variables,
  options
}) => {
  const {
    loading: lessonLoading,
    data,
    error
  } = useGetHydratedLessonQuery(Object.assign({
    variables
  }, options));
  return {
    lesson: data === null || data === void 0 ? void 0 : data.lesson,
    lessonLoading,
    lessonError: unwrapLessonChirpError(error)
  };
};
export const useFullLessonPublic = (lessonId, skip) => {
  const {
    loading: lessonLoading,
    data,
    error
  } = useGetByIdQuery({
    variables: {
      lessonId
    },
    skip
  });
  const {
    lesson,
    lessonError
  } = unwrapPublicLessonChirpError({
    error,
    data
  });
  return {
    lesson,
    lessonLoading,
    lessonError
  };
};